export { default } from "./Spacer-component";
